<h1>Before you start!</h1>

<p>Depending on the volume of events being processed, it can take up to 5-10 days for your event to appear on our
    websites.
    Please submit your event in plenty of time to allow it maximum exposure on our site.
</p>

<!-- <p>It is important that all businesses ensure compliance with the current <b><a href="https://covid19.failteireland.ie/operational-guidelines/" target="_blank">Government Operational Guidelines</a></b>.</p> -->
<p>
    Before you proceed please be advised that only events meeting the Fáilte Ireland events portal criteria will be accepted.
</p>
<br />
<app-criteria-form></app-criteria-form>

<br />